import React from "react";
import * as styles from "./Loader.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";

const Loader = ({ show = false, className }) => {
	const loaderClassName = classNames({
		[styles["loader"]]: true,
		[className]: !!className,
	});

	return (
		<CSSTransition
			in={show}
			timeout={1500}
			classNames={{
				enter: styles["fade-loader-enter"],
				enterActive: styles["fade-loader-enter-active"],
				exit: styles["fade-loader-exit"],
				exitActive: styles["fade-loader-exit-active"],
				exitDone: styles["fade-loader-exit-done"],
			}}
			mountOnEnter={true}
			unmountOnExit={true}
		>
			<div className={loaderClassName}>
				<div className={styles["lds-roller"]}>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
			</div>
		</CSSTransition>
	);
};

Loader.propTypes = {
	show: PropTypes.bool,
	className: PropTypes.string,
};

export default Loader;
